<template>
    <div class="device-add-page">
        <!-- 二维码卡片 -->
        <div class="qrcode-card">
            <img class="qrcode-img" :src="require('../assets/images/bindNoScanIcon.png')" />
        </div>

        <!-- 表单区域 -->
        <van-form class="device-form">
            <van-field v-model="form.deviceNo" required center clearable label="设备号:" placeholder="请输入设备号"
                :rules="[{ required: true, message: '请输入设备号' }]">
            </van-field>

            <van-field v-model="form.deviceNickname" center clearable label="设备昵称:" placeholder="昵称用于辨别不同的设备"
                :rules="[{ required: false, message: '请输入设备昵称' }]" />
        </van-form>

        <!-- 操作按钮 -->
        <div class="action-wrapper">
            <van-button type="primary" size="normal" :disabled="!form.deviceNo" class="add-btn"
                @click="handleAddDevice">
                添加/查询设备
            </van-button>
            <div class="switch-login">
                <span @click="handleSwitchLogin">已绑定设备，切换账号登录</span>
            </div>
        </div>
    </div>
</template>

<script>
import * as deviceApi from "@/api/device"
export default {
    name: 'DeviceAddPage',
    data() {
        return {
            form: {
                deviceNo: '',
                deviceNickname: ''
            },
            userId: ''
        }
    },
    mounted() {
        const userId = this.$route.query._u; // 用户id
        this.userId = userId;
        console.log('userId', userId);
    },
    methods: {
        async handleAddDevice() {
            if (!this.userId) {
                this.handleSwitchLogin();
                return;
            }

            const deviceValid = await this.getDevice(this.form.deviceNo);
            if (deviceValid) {
                try {
                    await deviceApi.bindDevice(this.userId, this.form.deviceNo, this.form.deviceNickname);
                } catch (error) {
                    console.log("设备绑定失败", error);
                };
                this.goDeviceHome(this.form.deviceNo);
            }
        },
        handleSwitchLogin() {
            this.$router.replace({
                path: "/register"
            })
        },
        async getDevice(deviceNo) {
            try {
                const data = await deviceApi.getDeviceInfo(deviceNo);
                console.debug("device", data);
                return true;
            } catch (error) {
                console.log("查询设备信息失败", error);
                if (error.status == '508') {
                    this.$toast('请输入正确的设备号');
                }
                return false;
            }
        },
        goDeviceHome(deviceNo) {
            this.$router.replace({
                path: '/deviceHome',
                query: {
                    _t: deviceNo
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.device-add-page {
    min-height: 100vh;
    background: #f8f9fa;
    padding: 20px;
    box-sizing: border-box;
}

.qrcode-card {
    width: 100%;
    /* 容器占满父级宽度，作为图片宽度的参考 */
    padding: 20px 0;

    .qrcode-img {
        width: 50%;
        height: auto;
        /* 核心：高度自动，保持原始比例 */
        margin: 0 auto;
        /* 横向居中 */
        display: block;
        /* 行内元素转块级，margin: 0 auto 才生效 */
        object-fit: contain;
    }
}

.device-form {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 30px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.action-wrapper {
    margin-top: 60px;
    text-align: center;

    .add-btn {
        width: 60%;
        border-radius: 24px;
        background: #5573f1;
        border: none;
        margin-bottom: 20px;
    }

    .switch-login {
        font-size: 12px;
        color: #858b95;
        text-decoration: underline;
    }
}
</style>
